import styled from "styled-components";
import { CARD_COLOR } from ".";

const Card = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px;
  flex: 1;
  justify-content: space-between;
  min-height: 160px;
`;

export const DefaultCard = styled(Card)`
  background-color: ${({ color }) => (color && color)};
`;

export const CardTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const TitleText = styled.div`
  color: ${({ color }) => (color === CARD_COLOR.BLUE ? '#fff': 'rgba(0, 0, 0, 0.87)')};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ContentText = styled.div`
  font-size: 24px;
  font-weight: 500;
`;

export const DefaultContentText = styled(ContentText)`
  color: ${({ color }) => (color === CARD_COLOR.BLUE ? '#fff': 'rgba(0, 0, 0, 0.87)')};
`;

const SecondContentText = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const DefaultSecondContentText = styled(SecondContentText)`
  color: ${({ color }) => (color === CARD_COLOR.BLUE ? '#fff': 'rgba(0, 0, 0, 0.87)')};
`;
